import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import { hasIntegrations } from './api/leagues';
import LandingPage from './components/LandingPage';
import LoadingScreen from './components/LoadingScreen';

const Home: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, signIn } = useAuth();
  const [isCheckingIntegrations, setIsCheckingIntegrations] = useState(false);

  useEffect(() => {
    // If already authenticated, check for integrations
    if (isAuthenticated && !isCheckingIntegrations) {
      checkIntegrationsAndRedirect();
    }
  }, [isAuthenticated, navigate, location]);

  const checkIntegrationsAndRedirect = async () => {
    setIsCheckingIntegrations(true);
    try {
      const hasLeagues = await hasIntegrations();
      
      // Redirect based on integration status
      if (hasLeagues) {
        navigate('/leagues', { replace: true });
      } else {
        navigate('/onboarding', { replace: true });
      }
    } catch (error) {
      console.error('Error checking integrations:', error);
      // On error, default to onboarding
      navigate('/onboarding', { replace: true });
    } finally {
      setIsCheckingIntegrations(false);
    }
  };

  if (isAuthenticated && isCheckingIntegrations) {
    return <LoadingScreen message="Loading..." />;
  }

  return <LandingPage onSignIn={signIn} />;
};

export default Home;